export default __webpack_public_path__ + "images/I6.27b6cba.png";